import React from "react";
import "../../css/components/controls/HrnbProgressBar.css";

export default function HrnbProgressBar({
    value = 0,
    max = 100,
    variant = "primary",
    showLabel = true,
    className = "",
    ...props
}) {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));

    return (
        <div
            className={`hrnb-progress-bar hrnb-progress-bar--${variant} ${className}`}
            {...props}
        >
            <div
                className="hrnb-progress-bar__fill"
                style={{ width: `${percentage}%` }}
            >
                {showLabel && (
                    <span className="hrnb-progress-bar__label">
                        {percentage.toFixed(1)}%
                    </span>
                )}
            </div>
        </div>
    );
}
